export default String.raw`
$('body').on("click", ".toggle-filters-menu-js", function(e) {
    const filters = $('.categories-and-filters-js');
    filters.toggle();
    app.setLockFocus(
        filters, 
        () => {
            filters.toggle()
            app.offLockFocus();
        }, 
        $(e.currentTarget));
});
`